module.exports = __webpack_public_path__ + "img/00-buger+mg.f03b5905.png";